// Self-contained data for the R. Talaba Accounting Firm concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/12_R_Talaba_Accounting_Firm
// (research snapshot 2026-08-21). Strong evidence (matching PRC address records) ties "R. Talaba"
// to Rabboni Seno Talaba, CPA — presented as strong association, not a confirmed "Founder" label,
// per the dossier's caution. Current BOA/BIR accreditation dates are not asserted without
// verification.
export const BIZ = {
  name: "R. Talaba Accounting Firm",
  tagline: "Smart & Practical Solutions to Your Business Needs",
  address: "2nd Floor, Victoria Building, M.L. Quezon St., Cabancalan II, Mandaue City, Cebu 6014",
  phone: "+63323466321",
  phoneDisplay: "(032) 346-6321",
  phoneAlt: "(032) 346-0927",
  email: "rtalaba@gmail.com",
  mapEmbed: "https://www.google.com/maps?q=Victoria+Building+M.L.+Quezon+St+Cabancalan+Mandaue+City&output=embed",
};

export const SERVICES = [
  { title: "Accounting", text: "General accounting services." },
  { title: "Tax Compliance", text: "Tax services and compliance support." },
  { title: "Business Registration", text: "SEC incorporation and business registration." },
  { title: "Permits & Compliance", text: "Business permits and regulatory compliance." },
  { title: "Audit", text: "Audit services." },
  { title: "Business Support", text: "Loan assistance and general business support." },
];

export const ABOUT = "Public records — including matching PRC address records — strongly associate this practice with Rabboni Seno Talaba, CPA, who also holds a Real Estate Broker license. Former staff and interns going back to 2016 indicate we've operated with accounting staff, not as a solo practice.";

export const REPUTATION = {
  rating: "5.0",
  reviewCountLabel: "5+ public reviews",
  note: "Individual review text was not recoverable — the rating reflects the aggregate shown in current public listings.",
};
